import { useMemo } from 'react';
import { DemeterMarket, DemeterTableDefinitionType } from '../../../../Generated/Raven-Demeter';
import useTableDefinitionsByCommodityApi from '../../../Apis/Hooks/useTableDefinitionsCommodityApiHook';
import useTableDefinitionNavigation from './useTableDefinitionNavigationHook';

const useMarketCommoditySelection = (): DemeterMarket | undefined => {
    const tableDefinitionsByCommodity = useTableDefinitionsByCommodityApi(DemeterTableDefinitionType.AllFundamentalsAndPrices, DemeterMarket.All);
    const [, , regionCommoditySelection] = useTableDefinitionNavigation(DemeterTableDefinitionType.AllFundamentalsAndPrices);

    const marketByCommodity = useMemo(() => {
        if (!regionCommoditySelection || !tableDefinitionsByCommodity) {
            return undefined;
        }

        const byCommodity = tableDefinitionsByCommodity.find(
            (x) =>
                x.commodity === regionCommoditySelection.commodity ||
                regionCommoditySelection.commodity === x.topLevelGroup ||
                x.demeterTableDefinitionSubCommodities.some(
                    (y) => y.commodity === regionCommoditySelection.commodity || y.topLevelGroup === regionCommoditySelection.commodity,
                ),
        );

        if (!byCommodity) {
            return undefined;
        }

        return byCommodity.market;
    }, [regionCommoditySelection, tableDefinitionsByCommodity]);

    return marketByCommodity;
};

export default useMarketCommoditySelection;
